<template>
  <div>
    <!--    头部门店信息-->
    <div class="storeList flex_center">
      <div class="storeList__img">
        <img :src="store.logo" alt />
      </div>
      <div class="storeList__content">
        <div class="mb_5">
          {{store.storename}}
          <span
            :class="['technician_status',store.status==2?'technicial_status_bg':'']"
          >{{store.status==2?'休息中':'营业中'}}</span>
        </div>
        <div class="col_999 fs_12">
          <p>电话：{{store.tel}}</p>
          <p v-if="store.sale_starttime!=0">营业时间：{{store.sale_starttime}}-{{store.sale_endtime}}</p>
          <p v-else>营业时间：全天营业</p>
        </div>
      </div>
    </div>
    <div class="mb_5">
      <div class="van-cell" @click="openMap">
        <div class="van-cell__title">
          <span>地址：{{store.address}}</span>
        </div>
        <i class="van-icon van-icon-location" :style="style">
          <!---->
        </i>
      </div>
      <van-cell :value="score+'分'" value-class="col_45B9BC" is-link @click="jump_comment()">
        <template slot="title">
          <span class="custom-title">评价</span>
          <span class="col_999 fs_12">({{store_comment_total}})</span>
        </template>
      </van-cell>
    </div>
    <!--    环境图片-->
    <div class="mb_5 storeDetails__intro" style="clear:both;overflow:hidden;padding-bottom:.5rem;">
      <div class="intro_title">
        <span class="title__tag">环境图片</span>
      </div>
      <div class="intro_content">
        <ul>
          <li
            class="store_img"
            v-for="(item,index) in store.environment_img_str"
            :key="index"
            @click="previewImage(item)"
          >
            <van-image width="100%" height="3.5rem" fit="cover" :src="item" />
          </li>
        </ul>
      </div>
    </div>
    <!--    简介-->
    <div class="mb_5 storeDetails__intro">
      <div class="intro_title">
        <span class="title__tag">简介</span>
      </div>
      <div class="intro_content">
        <div :class="[boxshow?'':'store_line']">{{store.desc}}</div>
        <div class="center">
          <button class="down__moreBtn" @click="boxshow = !boxshow">
            <van-icon v-if="!boxshow" name="arrow-down" />
            <van-icon v-if="boxshow" name="arrow-up" />
          </button>
        </div>
      </div>
    </div>
    <!--    服务、技师列表-->
    <van-tabs v-model="active" line-height="2px" color="#45B9BC" sticky>
      <van-tab title="养生服务">
        <template v-if="itemList != ''">
          <van-list
            v-model="service_loading"
            :finished="service_finished"
            finished-text="没有更多内容啦..."
            @load="onLoad"
          >
            <router-link
              :to="{ path: '/itemDetails', query: { service_id: item.id ,store_id:store_id}}"
              class="storeList flex_center"
              v-for="(item,index) in itemList"
              :key="index"
            >
              <div class="storeList__img itemList__img">
                <img :src="item.thumb_frist" alt />
              </div>
              <div class="storeList__content">
                <div>{{item.title}}</div>
                <div class="col_999 fs_12 mb_5 one">{{item.desc}}</div>
                <div class="itemList_price fs_12">
                  <span>¥{{item.price}} 起</span>
                  {{item.itemtime}}分钟/次
                </div>
              </div>
            </router-link>
          </van-list>
        </template>
        <template v-else>
          <div class="item_none">暂无服务项目</div>
        </template>
      </van-tab>
      <van-tab title="养生技师">
        <template v-if="techList != ''">
          <van-list
            v-model="tech_loading"
            :finished="tech_finished"
            finished-text="没有更多内容啦..."
            @load="onLoad"
          >
            <div class="tech_level">
              <div
                @click="select_level(level_item.id)"
                :class="['evaluate__tabTitle',level_active==level_item.id?'active':'']"
                v-for="(level_item,level_index) in tech_level"
                :key="level_index"
              >
                <span>{{level_item.title}}</span>
              </div>
            </div>

            <div
              class="storeList flex_center techList"
              v-for="(techItem,techIndex) in techList"
              :key="techIndex"
            >
              <!--技师头像-->
              <div class="tech__headBox" v-if="techItem.type=='0'">
                <img class="tech__headImg" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
              </div>
              <div class="tech__headBox" v-if="techItem.type=='2'">
                <img
                  class="tech__headImg seniorTech"
                  :src="techItem.thumb?techItem.thumb:techItem.avatar"
                  alt
                />
                <img class="tech__head_crown" src="/static/img/crown_icon.png" alt />
              </div>
              <!--技师内容-->
              <div class="storeList__content">
                <div class="flex_center techList__title">
                  <span>{{techItem.name}}</span>
                  <div class="detail_star">
                    <span v-for="(item,index) in 5" :key="index">
                      <van-icon
                        class="star"
                        size="15px"
                        name="star"
                        v-if="techItem.score > index"
                        :color="star_active"
                      />
                      <van-icon class="star" size="15px" name="star" v-else />
                    </span>
                  </div>
                </div>
                <div class="col_999 fs_12">
                  <p>{{techItem.levlename}}</p>
                  <div class="flex techList__line">
                    <div>个人编号：{{techItem.num_id}}</div>
                    <router-link
                      :to="{ path: '/technicianDetails', query: { tech_id: techItem.id ,store_id:store_id}}"
                      class="techList__btn"
                    >立即预约</router-link>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </template>
        <template v-else>
          <div class="item_none">暂无技师</div>
        </template>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: "storeDetails",
  data() {
    return {
      store_id: 0,
      store_comment_total: 0,
      score: 0,
      service_loading: false,
      service_finished: true,
      tech_loading: false,
      tech_finished: true,
      //门店列表
      store: [],
      // 简介内容
      intro_content: "",
      active: 0, // 标签当前所在位置
      //项目列表
      itemList: [],
      star_active: "#F9CE06", //星星
      //技师列表
      techList: [],
      boxshow: false,
      style:
        "line-height: inherit;font-size:1rem;color:#45b9bc;width:10%; float:right",
      tech_level: [],
      level_active: 0
    };
  },

  created() {
    this.store_id = this.$route.query.id;
    this.get_store();
  },
  methods: {
    select_level(level_id) {
      this.level_active = level_id;
      this.get_store();
    },
    jump_comment() {
      if (this.store_comment_total > 0) {
        this.$router.push({
          path: "/evaluate",
          query: { store_id: this.store.id }
        });
      }
    },
    get_store() {
      this.axios({
        url: this.api.store.store_detail,
        data: {
          store_id: this.store_id,
          tech_level_id: this.level_active
        }
      }).then(res => {
        if (res.error === 0) {
          let p = new Promise((resolve, reject) => {
            this.store = res.store_data;
            this.itemList = res.store_service;
            this.techList = res.store_tech;
            this.store_comment_total = res.store_comment_total;
            this.score = res.score;
            this.tech_level = res.tech_level;
            this.level_active = res.select_level;
          });
          p.then(data => {
            this.share();
          });
        }
      });
    },
    previewImage(url) {
      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: this.store.environment_img_str // 需要预览的图片http链接列表
      });
    },
    openMap() {
      var lat = this.store.lat;
      var lng = this.store.lng;
      var address = this.store.address;
      var storename = this.store.storename;

      this.axios({
        url: this.api.index.share_url,
        data: {
          url: window.location.href.split("#")[0]
        }
      }).then(function(res) {
        var shareMsg = res.jssdkconfig;
        wx.config({
          // debug:true,
          appId: shareMsg.appId,
          timestamp: shareMsg.timestamp,
          nonceStr: shareMsg.nonceStr,
          signature: shareMsg.signature,
          jsApiList: ["openLocation"]
        });

        wx.ready(function() {
          wx.openLocation({
            latitude: parseFloat(lat), // 纬度，浮点数，范围为90 ~ -90
            longitude: parseFloat(lng), // 经度，浮点数，范围为180 ~ -180。
            name: storename, // 位置名
            address: address, // 地址详情说明
            scale: 28, // 地图缩放级别,整形值,范围从1~28。默认为最大
            infoUrl: "" // 在查看位置界面底部显示的超链接,可点击跳转
          });
        });
      });
    },
    share() {
      this.axios({
        url: this.api.index.shareconfig
      }).then(res => {
        if (res.error === 0) {
          this.wx.wxShare({
            title: this.store.storename,
            desc: res.shareconfig.desc,
            imgUrl: this.store.logo,
            link: window.location.href,
            toast: "hide"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/store.css"; /*门店样式*/
@import "../../../assets/css/item.css"; /*服务项目*/
@import "../../../assets/css/technician.css"; /*技师*/
.store_line {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  padding-top: 10px;
}
.technician_status {
  text-align: right;
  float: right;
  color: white;
  background-color: #45b9bc;
  border-radius: 5px;
  padding: 0.2rem 0.5rem;
}
.technicial_status_bg {
  background-color: #d2d2d2;
}
.store_img {
  width: 25%;
  float: left;
  padding: 1%;
}
.van-icon-location:before {
  display: block;
  float: right;
}

.tech_level {
  background: white;
  margin-top: 0.2rem;
  overflow: hidden;
  text-align: center;
  /* margin: 0.5rem 0; */
  margin-bottom: 0.5rem;
}
.evaluate__tabTitle {
  color: #999;
  border: 1px solid #ccc;
  line-height: 1.2rem;
  margin: 0.45rem 0.1rem;
  border-radius: 1.2rem;
  font-size: 0.6rem;
  display: inline-block;
  margin-left: 0.5rem;
}
.evaluate__tabTitle span {
  padding: 0.5rem;
}
.active {
  color: #45b9bc;
  border-color: rgba(69, 185, 188, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/views/book/store/storeDetails.vue